import { PortalModule } from '@angular/cdk/portal';
import { NgIf, NgStyle } from '@angular/common';
import { Component, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import moment, { duration } from 'moment';
import { DialogService, FlyoutService, NavigationService } from '@app/core/services';
import { SalesTaxDueInfo } from '@app/models/fund-management/account-payable/sales-tax-due-info.model';
import { BaseFlyoutComponent } from '@app/shared/components/base-flyout.component';
import { SalesTaxInvoiceParamsFormService } from './services/sales-tax-invoice-params.service';

@Component({
	selector: 'sl-sales-tax-invoice-params',
	templateUrl: './sales-tax-invoice-params.component.html',
	styleUrls: ['./sales-tax-invoice-params.component.less'],
	standalone: true,
	imports: [MatButtonModule, PortalModule, MatIconModule, NgIf, NgStyle, FormsModule, MatFormFieldModule, MatDatepickerModule],
})
export class SalesTaxInvoiceParamsComponent extends BaseFlyoutComponent {
	@Output() createResult: EventEmitter<number> = new EventEmitter<number>();

	@ViewChild('salesTaxInvoiceParamsForm') salesTaxInvoiceParamsForm: NgForm;

	dateRangeWidth = '300px';
	dateFrom: Date = null;
	dateTo: Date = null;
	datesValid = false;
	isDataLoaded = false;
	datesErrorMessage = '';
	info = new SalesTaxDueInfo();

	constructor(
		protected navigationService: NavigationService,
		protected dialog: MatDialog,
		protected readonly dialogService: DialogService,
		protected readonly flyoutService: FlyoutService,
		private readonly service: SalesTaxInvoiceParamsFormService
	) {
		super(flyoutService, dialogService);
	}

	@HostListener('window:beforeunload')
	canDeactivate = (): boolean => true;

	onDatesChange(): void {
		this.isDataLoaded = false;
		this.datesErrorMessage = '';
		this.datesValid = true;

		if (this.dateFrom === null || this.dateTo === null) {
			this.datesValid = false;
			return;
		}

		const period = duration(moment(this.dateTo).diff(this.dateFrom));
		if (period.asYears() > 1) {
			this.datesValid = false;
			this.datesErrorMessage = 'Max period is one year';
		}

		this.dateFrom = new Date(moment(this.dateFrom).format('YYYY-MM-DD HH:MM:SS'));
		this.dateTo = new Date(moment(this.dateTo).format('YYYY-MM-DD HH:MM:SS'));

		if (this.datesValid) {
			this.loadData();
		}
	}

	onGetInvoiceData(): void {
		this.loadData();
	}

	submitSalesTaxInvoiceParams(): void {
		this.service.createSalesTaxDueInvoice(this.dateFrom, this.dateTo).subscribe((data: any) => {
			this.dateFrom = null;
			this.dateTo = null;
			this.isDataLoaded = false;
			this.createResult.emit(data);
			this.close();
		});
	}

	private loadData(): void {
		this.service
			.getSalesTaxDueInfo(this.dateFrom, this.dateTo)
			.subscribe((data: any) => {
				this.info = Object.assign({}, data);
			})
			.add(() => {
				this.isDataLoaded = true;
			});
	}
}
